import { Injectable } from '@angular/core';
import { BaseApiCaller } from '../base-api-caller';
import { DictionaryModel } from '../../models/dictionary-model';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class SpecialProperiesApiCallerService extends BaseApiCaller {
  protected controllerPath = 'specialProperties';

  // constructor(httpClient: HttpClient, private datePipe: DatePipe) {
  //   super(httpClient);
  //}
  constructor(httpClient: HttpClient) {
    super(httpClient);
  }

  public getAll() {
    return this.get<DictionaryModel<string>[]>('');
  }
}
